import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
  const { user } = useAuth0();
  const { name, picture, email, nickname, updated_at } = user;

  // Extracted data to display
  const displayData = [
    { key: "Nickname", value: nickname },
    { key: "Last Updated", value: new Date(updated_at).toLocaleString() },
    { key: "Email", value: email }
  ];

  return (
    <div className="profile-container">
      <div className="profile-picture-container">
        <img
          src={picture}
          alt="Profile"
          className="profile-picture"
        />
      </div>
      <div className="profile-details">
        <h2 className="profile-name">{name}</h2>
        <p className="profile-email">{email}</p>
      </div>
      <div className="user-data-container">
        {displayData.map((data, index) => (
          <div key={index} className="user-data-card">
            <h3 className="data-key">{data.key}</h3>
            <p className="data-value">{data.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
